// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressBlockStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/AddressBlockStyle";
import { myAccountsDetailsHeaderStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/MyAccountsDetailsHeaderStyle";
import { orderInfoStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/OrderInfoStyle";
import { orderSummeryTableStyles } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/OrderSummeryTableStyles";
import Print from "@hardwoods/XDL/Icons/Print";
import { iconButtonCommonStyles } from "@hardwoods/XDL/Utilities/iconButtonCommonStyles";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { css } from "styled-components";

// For some buttons in MyAccount details pages
export const buttonsSetStyle: { printButton?: ButtonPresentationProps } = {
    printButton: {
        ...iconButtonCommonStyles(Print, {
            sizeVariant: "small",
        }),
    },
};

// Quote proposed cart lines count
export const cartLinesCountStyle = {
    variant: "h5",
    as: "h5",
    weight: 400,
    css: css`
        margin-bottom: 0;
    `,
} as TypographyPresentationProps;

export const productDescriptionStyle = {
    productDetailLink: {
        color: "secondary.main",
        css: css`
            min-height: 37px;
            margin-bottom: 7px;
            display: inline-flex;
        `,
        typographyProps: {
            color: "secondary.main",
            size: 16,
            css: css`
                width: 100%;
                line-height: 18px;
                letter-spacing: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                max-height: calc(4 * 18px);
                -webkit-line-clamp: 2;
                ${wrapInContainerStyles}
            `,
        },
    },
};

export const buttonsStyle = css`
    ${xScreen.lte("xs")} {
        width: 100%;
    }
`;

export { orderSummeryTableStyles, myAccountsDetailsHeaderStyle, addressBlockStyle, orderInfoStyle };
